import { createSlice } from '@reduxjs/toolkit';
import { REDUX_STORE_SLICES } from '../../services/exports/Constants';
import { IMarketingState } from '../types';
import { ActionPayloadInterface } from '../../services/exports/Interfaces';

export default createSlice({
  name: REDUX_STORE_SLICES.MARKETING,
  initialState: {
    mobile_app: {
      download_modal_seen: false,
    },
  },
  reducers: {
    updateMobileApp: (state: IMarketingState, action: ActionPayloadInterface<Partial<IMarketingState>>) => {
      state.mobile_app = {
        ...state.mobile_app,
        ...action.payload,
      };
    },
  },
});

export const props = (state: IMarketingState) => state;
